import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { actionCreators } from "./redux/goalsSummarySagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import ClosestToCompletion from "./smartComponents/closestToCompletion";
import LeastLikelyToSucceed from "./smartComponents/leastLikelyToSucceed";
import GoalsToWatch from "./smartComponents/goalsToWatch";
import { getCurrentMonthAndYear } from "../../../utils/modules";
import LearnMore from "../../../components/learnMore/learnMore";
import { useFetchData } from "../hooks/dataFetchingHooks";

const GoalsSummaryModule = (props) => {
  useFetchData({
    moduleName: "goalsSummary",
    props,
    fetchData: actionCreators.fetchCurrentUser,
    updateData: actionCreators.updateAllData
  });

  const isLoading = useSelector((state) => state.goalsSummary.isLoading);
  const goalsToWatch = useSelector((state) => state.goalsSummary.goalsToWatch);
  const worstPerformingGoal = useSelector((state) => state.goalsSummary.worstPerformingGoal);
  const [worstPerformingGoalShow, setWorstPerformingGoalShow] = useState(false);

  useEffect(() => {
    if (Object.keys(worstPerformingGoal).length !== 0 && typeof worstPerformingGoal === "object") {
      setWorstPerformingGoalShow(true);
    } else {
      setWorstPerformingGoalShow(false);
    }
  }, [worstPerformingGoal]);

  return (
    <SectionToggle
      title={`Goals to Watch | ${getCurrentMonthAndYear(props.calendarEndDate)}`}
      learnMore={<LearnMore {...learnMoreProps()} />}
      showCta={goalsToWatch.length > 0}
      ctaContent="View All Goals"
      ctaLink={props.allGoalsUrl}
      customClass="goals-summary"
      height={400}
      isLoading={isLoading}
      content={
        goalsToWatch.length > 0 ? (
          <div className="goals-summary-wrapper">
            <div className="goal-donut">
              <ClosestToCompletion />
            </div>
            {worstPerformingGoalShow ? (
              <div className="goal-donut">
                <LeastLikelyToSucceed />
              </div>
            ) : (
              <div className="goal-donut" />
            )}
            <div className="goals-to-watch">
              <GoalsToWatch />
            </div>
          </div>
        ) : (
          <div>
            <p
              className="no-goals-active"
              style={{
                textAlign: "center",
                paddingTop: "11%",
                fontSize: "22px",
                color: "#6f7077"
              }}
            >
              You currently have no active goals, please set at least one goal.
              <br />
              <a style={{ left: "0", top: "13px" }} className="cta" href={props.allGoalsUrl}>
                Go to Goals Page
              </a>
            </p>
          </div>
        )
      }
    />
  );
};

export default GoalsSummaryModule;

const learnMoreProps = () => {
  return {
    title: "Goals to Watch",
    content: (
      <>
        This module shows an overview of the current months goals, MTD.
        <br />
        <br />
        <h3>Most Likely To Succeed</h3>
        The goal most likely to reach target based on currently monthly projections.
        <br />
        <br />
        <h3>Least Likely To Succeed</h3>
        The goal least likely to reach target based on currently monthly projections.
        <br />
        <br />
        <h3>Goals To Watch</h3>
        User defined list of goals to watch.
        <br />
        <br />
        NOTE: The dashboard date selector does not affect this module. It will always display the
        current months goals.
      </>
    )
  };
};
